import React from 'react';
import {Button,Badge} from 'reactstrap';
import {SendingAudio} from './Loading';
import {baseUrl} from '../shared/baseUrl';

class AudioVerification extends React.Component{
    constructor(props){
        super(props);
        this.state={
            fetchedAudio:"",
            audioId:"",
            verifyHindiText:"",
            wavFileURL:"",
            speaker:"",
            audioControls:false,

            // Animation
            divSending:"none",
            displayVerifier:"none",

            // wavPlayback
            playbackText:"Play",
            faClass:"ml-1 fa fa-play",
            isPlaying:false,

            // Count number of verifications
            verifyCount:localStorage.getItem("verified")
        }
        this.verifyAudio = React.createRef();
    }

    componentDidMount = ()=>{
        // this.getAudio();
        var s ="https://drive.google.com/file/d/1Z0QD4VSZIvisvF3uCNafvPHdD0TiuxAz";
        // var input = "https://drive.google.com/file/d/78BygKccgGms9ET2lUM0RPVUI1T0U/view?usp=sharing";
        // var res = input.match(/https:\/\/drive.google.com\/file\/d\/([a-zA-Z0-9_]+)\//);
        // console.log(res[1]);
        // src="http://docs.google.com/uc?export=open&id="+"1Z0QD4VSZIvisvF3uCNafvPHdD0TiuxAz"
    }

    getAudio = () =>{
        this.setState({
            divSending:"none",
            displayVerifier:"none",
        })
        // set audio to be played
        var verifyAudio = this.verifyAudio.current;
        const bearer = 'Bearer ' + localStorage.getItem('token');
        return fetch(baseUrl+'audio/getFileAsync',{
            method: 'GET',
            headers: {
                "Content-Type": "text/html",
                'Authorization': bearer
            },
            credentials: 'same-origin'
        })
        .then(response =>{
            if(response.ok){
                return response;
            }
            else{
                var error = new Error("Response failed!!");
                error.response = response;
                throw error;
            }
        },(err)=>{
            var errmess = new Error(err.message+"hulalalala")
            throw errmess;
        })
        .then(response=>response.json())
        .then((data)=>{
            console.log("this",data);
            // verifyAudio.setAttribute('controls', true);
            // verifyAudio.setAttribute('src', "https://localhost:3443/"+data.fileName+'.wav');
        })
        .catch((err)=>console.log("Error while Fetching data for verification: ",err));
    }
    // custom playback control
    playbackButtonSubmit = ()=>{
        var playbackAudio = this.verifyAudio.current;
        playbackAudio.volume=1;
        if(!this.state.isPlaying){
            this.setState({
                playbackText:"Pause",
                isPlaying:!this.state.isPlaying,
                faClass:"fa fa-pause ml-1"
            });
            console.log("Herer");
            playbackAudio.play();
        }
        else{
            this.setState({
                playbackText:"Play",
                isPlaying:!this.state.isPlaying,
                faClass:"fa fa-play ml-1"
            });
            playbackAudio.pause();
        }
    }

    playbackOnEnd = () =>{
        this.setState({
            playbackText:"Play",
            isPlaying:!this.state.isPlaying,
            faClass:"fa fa-play ml-1"
        });
    }


    // renameFiles = ()=>{
    //     const bearer = 'Bearer ' + localStorage.getItem('token');
    //     return fetch(baseUrl+'audio/renameFiles',{
    //         method: 'GET',
    //         headers: {
    //             "Content-Type": "text/html",
    //             'Authorization': bearer
    //         },
    //         credentials: 'same-origin'
    //     })
    //     .then(response =>{
    //         if(response.ok){
    //             return response;
    //         }
    //         else{
    //             var error = new Error("Response failed!!");
    //             error.response = response;
    //             throw error;
    //         }
    //     },(err)=>{
    //         var errmess = new Error(err.message+"hulalalala")
    //         throw errmess;
    //     })
    //     .then(response=>response.json())
    // }

    // revertNameChange = ()=>{
    //     const bearer = 'Bearer ' + localStorage.getItem('token');
    //     return fetch(baseUrl+'audio/revertFileNameChange',{
    //         method: 'GET',
    //         headers: {
    //             "Content-Type": "text/html",
    //             'Authorization': bearer
    //         },
    //         credentials: 'same-origin'
    //     })
    //     .then(response =>{
    //         if(response.ok){
    //             return response;
    //         }
    //         else{
    //             var error = new Error("Response failed!!");
    //             error.response = response;
    //             throw error;
    //         }
    //     },(err)=>{
    //         var errmess = new Error(err.message+"hulalalala")
    //         throw errmess;
    //     })
    //     .then(response=>response.json())
    // }

    add

    render(){
        return(
        <div>
            <div className="mt-1" >
                <div className="row mt-auto ">
                    <div className="col">
                        <h6><Badge>Listen</Badge></h6>
                        {/* <h5>{this.state.verifyHindiText}</h5> */}
                    </div>
                </div>
                <div className="row">
                    <div className="ml-3">
                        <audio 
                            ref={this.verifyAudio} 
                            controlsList="nodownload"
                            controls="true"
                            src="http://docs.google.com/uc?export=open&id=1Z0QD4VSZIvisvF3uCNafvPHdD0TiuxAz"
                            onEnded={this.playbackOnEnd}>
                            This Browser is not supported.<br/> Download Latest Chrome or Firefox browser.</audio>
                    </div>
                </div>
            </div>
            <Button
                color="danger"
                onClick={this.renameFiles}
                >Rename</Button>
            <div className="mt-2">
                <Button 
                    color="primary"
                    onClick={this.revertNameChange}
                    >Revert</Button>
            </div>
        </div>
        )
    }
}

export default AudioVerification;